import { useCallback } from "react";
import { useUrlSheet } from "@/shared/ui";
import { useSession } from "./useSession";

/** What to do once the customer has signed in through the sheet (one at a time). */
let pending: (() => void) | undefined;

export const LOGIN_SHEET = "login";

/** Takes the action waiting for the login (the sheet runs it after a successful sign-in). */
export function takePendingAction(): (() => void) | undefined {
  const action = pending;
  pending = undefined;
  return action;
}

/**
 * Runs an action that needs a signed-in customer (D31): at once when signed in, otherwise after a login in the sheet
 * over the current page — the customer keeps their place («В рассрочку», «Оформить», «Оплатить»).
 */
export function useRequireLogin(): (action: () => void) => void {
  const { status } = useSession();
  const [, setOpen] = useUrlSheet(LOGIN_SHEET);
  return useCallback(
    (action: () => void) => {
      if (status === "authenticated") {
        action();
        return;
      }
      pending = action;
      setOpen(true);
    },
    [status, setOpen],
  );
}
